import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  generateRecaptchaToken
} from "./chunk-W4XMZLKW.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/devices/activate.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var activateDevice = (_0) => __async(void 0, [_0], function* ({
  draft_trusted_device_id,
  activation_code,
  locale
}) {
  try {
    const captcha = yield generateRecaptchaToken("activate_device");
    const lang = getLocaleOnly(locale);
    const data = yield fetchClient({
      url: `/device-activation-code/add-trusted-device?lang=${lang}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          lang,
          draft_trusted_device_id,
          activation_code,
          captcha
        })
      }
    });
    if (data.status !== "success") {
      throw data;
    }
    return data.data;
  } catch (error) {
    throw new Exception({ error, name: "activateDeviceException" });
  }
});

export {
  activateDevice
};
//# sourceMappingURL=chunk-656IUB4B.mjs.map